export const bwatFilterRange = {
  minValue: 0,
  maxValue: 65
};
